export * from "./verify-photo.component";
